import { post } from '../index';

export const createRevision = data => {
  return post('/revision', data);
};